import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Ein sauberes Material 3 inspiriertes Theme erstellen
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#6750A4' }, // Typisches M3 Violett
    secondary: { main: '#625B71' },
    error: { main: '#B3261E' },
    background: { default: '#FEF7FF', paper: '#FFFFFF' },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);